export default "---\nname: CORE battery\ncount: 1\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"